import { Instagram } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { INSTAGRAM_POSTS, SITE } from "@/data/site";
import { ProductImage } from "./ProductImage";

export const InstagramGrid = () => (
  <section id="instagram" data-testid="instagram-section" className="py-16 md:py-24 lg:py-32 bg-ivory">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-wrap items-end justify-between gap-6">
        <SectionHeading
          eyebrow="Sosyal Medya"
          title={<>Bizi Takip Edin — <span className="italic text-emerald">@{SITE.instagram}</span></>}
          testId="instagram"
        />
        <Reveal delay={0.15}>
          <a
            href={`https://instagram.com/${SITE.instagram}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-follow-button"
            className="inline-flex items-center gap-2 rounded-full border border-emerald/20 px-6 h-11 text-[13px] font-semibold text-emerald transition-colors duration-300 hover:bg-emerald hover:text-ivory"
          >
            <Instagram size={15} />
            Instagram'da Takip Et
          </a>
        </Reveal>
      </div>

      <div className="mt-10 md:mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4">
        {INSTAGRAM_POSTS.map((post, i) => (
          <Reveal key={post.src} delay={i * 0.06}>
            <a
              href={post.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`instagram-post-${i + 1}`}
              className="group relative block aspect-square overflow-hidden bg-white border border-gold-muted/50"
            >
              <ProductImage
                src={post.src}
                alt={post.name}
                className="h-full w-full object-contain p-4 transition-transform duration-700 ease-out group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-emerald/60 opacity-0 transition-opacity duration-500 group-hover:opacity-100 flex items-center justify-center">
                <Instagram size={22} className="text-ivory" />
              </div>
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
